<template>
    <div class="container stretched-container">
        <div class="tag-timer">
            <div v-if="banner" class="row align-items-center">
                <!--/* BANNER */-->
                <div class="col-auto p-0">
                    <div class="ob1-tag ob1-tag-primary">
                        <span>{{ banner }}</span>
                    </div>
                </div>
                <!--/* TIMER */-->
                <div v-if="timerEndDateInMilliseconds" class="col-auto">
                    <timer
                        :end-date-in-milliseconds="timerEndDateInMilliseconds"
                        :color="countDownColor"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "TagTimerBanner",
    props: {
        banner: {
            type: String,
            required: false,
            default: undefined
        },
        timerEndDateInMilliseconds: {
            type: Number,
            required: false,
            default: undefined
        },
        countDownColor: {
            type: String,
            required: false,
            default: ""
        }
    },
    computed: {
    },
    methods: {
    }
}
</script>

<style scoped lang="scss">

</style>
